import React, { Component } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Map } from "immutable";

const disabledStyle = {
  color: "rgba(255, 255, 255, 0.5)",
  cursor: "not-allowed"
};

export default class RecordPager extends Component {
  renderPrevious() {
    const { record, baseUrl, getUrl } = this.props;
    const previousId = record.get("previous_record_id");

    return previousId ? (
      <Link to={getUrl(baseUrl, previousId)}>
        <i className="fa fa-angle-left" />
      </Link>
    ) : (
      <i className="fa fa-angle-left" style={disabledStyle} />
    );
  }

  renderNext() {
    const { record, baseUrl, getUrl } = this.props;
    const nextId = record.get("next_record_id");

    return nextId ? (
      <Link to={getUrl(baseUrl, nextId)}>
        <i className="fa fa-angle-right" />
      </Link>
    ) : (
      <i className="fa fa-angle-right" style={disabledStyle} />
    );
  }

  render() {
    return (
      <span className="page-header-pagination" style={{ marginLeft: "-5px" }}>
        &nbsp;{this.renderPrevious()}&nbsp;&nbsp;{this.renderNext()}&nbsp;
      </span>
    );
  }
}

RecordPager.propTypes = {
  baseUrl: PropTypes.string.isRequired,
  record: PropTypes.instanceOf(Map),
  getUrl: PropTypes.func
};

RecordPager.defaultProps = {
  getUrl: (baseUrl, id) => `${baseUrl}/${id}`
};



// WEBPACK FOOTER //
// ./app/modules/shared/components/RecordPager/RecordPager.jsx